<template>
  <div class="info-region-container" style="height: 100vh; width: 100%" v-allow="'0903'">
    <div class="all-content-container">
      <div class="info-title-container container-user">
        <div class="title_muen">
          <h4>角色管理</h4>
          <el-button v-allow="'090302'" type="primary" class="adduser" @click="add">添加</el-button>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="角色：" prop="role">
            <el-input v-model="formInline.role" placeholder="请输入角色" maxlength="20" clearable></el-input>
          </el-form-item>

          <el-form-item v-allow="'090301'">
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="button" @click="usrReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="info-content-container">
        <div class="table_content1">
          <el-table :data="tableData" align="center" boder class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#f4f5f7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="角色"></el-table-column>
            <el-table-column prop="describes" align="center" label="描述"></el-table-column>

            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button v-allow="'090303'" @click="handleClickRole(scope.row.id, 'edit')" type="text" size="small">编辑</el-button>
                <el-button v-allow="'090304'" type="text" size="small" @click="delRole(scope.row.id)">删除</el-button>
                <el-button v-allow="'090305'" type="text" size="small" @click="openAuthority(scope.row.id)">权限</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page">
          </div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" :before-close="resetForm" width="600px" center style="z-index: 10000">
          <div class="info-content-container info-content-container-add">
            <el-form :inline="true" :model="dialogformInline" :rules="dialogRules" ref="REFdialogformInline" style="margin-left: 80px">
              <el-form-item label="角色：" prop="role">
                <el-input class="dialogformInline1" v-model="dialogformInline.role" placeholder="请输入角色" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="描述：" prop="description">
                <el-input v-model="dialogformInline.description" placeholder="请输入描述" class="dialogformInline1" maxlength="50"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm">取 消</el-button>
            <el-button type="primary" @click="submitForm('REFdialogformInline')">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="权限" :visible.sync="isPermissionsDialog">
          <el-form>
            <el-form-item label>
              <div class="permissions">
                <div v-for="item in permissionsArr" :key="item.id" class="oneClass">
                  <div class="onecheckbox">
                    <el-checkbox @change="handleChecked1(item)" v-model="item.isCheck" :label="item.name" name="type" :value="item.id"></el-checkbox>
                  </div>
                  <div class="oneBox">
                    <div v-for="itemtow in item.nextMenus" :key="itemtow.id + '75897'" class="twoClass">
                      <div class="twocheckbox">
                        <el-checkbox @change="handleChecked2(itemtow, item)" v-model="itemtow.isCheck" :label="itemtow.name" name="type" :value="itemtow.id"></el-checkbox>
                      </div>
                      <div v-for="itemtre in itemtow.nextMenus" :key="itemtre.id + '7592'">
                        <div class="trecheckbox">
                          <el-checkbox @change="handleChecked3(itemtre, itemtow, item)" v-model="itemtre.isCheck" :label="itemtre.name" name="type" :value="itemtre.id"></el-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <div class="btnPermissions">
              <el-button class="btn" @click="isPermissionsDialog = false">取 消</el-button>
              <el-button class="btn" type="primary" @click="submitFormR()">确 定</el-button>
            </div>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'roleManagement',
  data() {
    return {
      isPermissionsDialog: false,
      permissionsArr: [],
      checkedAuthority: [],
      eid: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      editId: '', //编辑id
      loading: false,
      dialogTitle: '',
      centerDialogVisible: false, //添加弹框
      pagesize: 6,
      currentPage: 1,
      total: 0,
      id: '',

      formInline: {
        //查询条件
        role: ''
      },
      dialogformInline: {
        //添加，编辑（参数）
        description: '', //描述
        role: '' // 角色
      },
      dialogRules: {
        // 弹框表单验证
        description: [{ required: true, message: '请输入描述', trigger: 'change' }],
        role: [{ required: true, message: '请输入角色', trigger: 'change' }]
      },
      modelNoListData: [
        {
          label: '全部',
          id: -1
        },
        {
          label: '管理员',
          id: 0
        },
        {
          label: '普通用户',
          id: 1
        }
      ],
      organizationList: [
        {
          label: '全部',
          id: -1
        },
        {
          label: '武汉',
          id: 0
        },
        {
          label: '上海',
          id: 1
        }
      ],
      tableData: []
    }
  },

  computed: {},
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    handleChecked1(item) {
      for (let i of item.nextMenus) {
        i.isCheck = item.isCheck
        for (let j of i.nextMenus) {
          j.isCheck = item.isCheck
        }
      }
    },
    handleChecked2(item, previtem) {
      previtem.isCheck = true
      for (let i of item.nextMenus) {
        i.isCheck = item.isCheck
        for (let j of i.nextMenus) {
          j.isCheck = item.isCheck
        }
      }
    },
    handleChecked3(item, previtem, itemtre) {
      itemtre.isCheck = true
      previtem.isCheck = true
    },
    submitFormR() {
      let permissionsArr = this.permissionsArr
      let arr = []
      for (let i of permissionsArr) {
        if (i.isCheck == true) {
          arr.push(i.id)
        }
        for (let item of i.nextMenus) {
          if (item.isCheck == true) {
            arr.push(item.id)
          }
          for (let j of item.nextMenus) {
            if (j.isCheck == true) {
              arr.push(j.id)
            }
          }
        }
      }
      this.$api.system
        .saveRoleMenus({ roleId: this.eid, menuIds: arr })
        .then((res) => {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.isPermissionsDialog = false
        })
        .catch((err) => {
          console.log(err)
        })
    },
    openAuthority(id) {
      this.eid = id
      this.$api.system
        .getRoleMenus({ id: id })
        .then((res) => {
          let permissionsArr = res.data
          for (let i of permissionsArr) {
            if (i.isCheck == 1) {
              i.isCheck = true
            }
            for (let item of i.nextMenus) {
              if (item.isCheck == 1) {
                item.isCheck = true
              }
              for (let j of item.nextMenus) {
                if (j.isCheck == 1) {
                  j.isCheck = true
                }
              }
            }
          }
          this.permissionsArr = permissionsArr
        })
        .catch((err) => {
          console.log(err)
        })
      this.isPermissionsDialog = true
    },
    init() {
      this.getRoleMessageList() //列表信息
    },
    resetForm() {
      this.centerDialogVisible = false
      // this.$refs['REFdialogformInline'].resetFields();
      this.dialogformInline = {
        //添加，编辑（参数）
        description: '', //描述
        role: '' // 角色
      }
    },
    // 查询
    onSubmit() {
      this.getRoleMessageList() //列表信息
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getRoleMessageList()
    },
    //获取列表信息
    getRoleMessageList() {
      this.loading = true //开启加载
      this.$api.system
        .getRoleMessageList(
          this.currentPage,
          this.pagesize,
          this.formInline.role //角色
        )
        .then((res) => {
          if (res.code == 200) {
            this.loading = false //关闭
            this.tableData = res.data
            this.total = res.count
          } else {
            this.loading = false //关闭
          }
        })
    },
    //删除按钮
    delRole(id) {
      console.log(id)
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.system.delfun(`/pc/sysRole/delSysRole`, id).then((res) => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.getRoleMessageList() //列表刷新
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    //   添加
    add() {
      this.resetForm()
      this.dialogTitle = '添加角色'
      this.centerDialogVisible = true
    },
    handleClickRole(id, type) {
      //编辑

      if (type == 'edit') {
        this.editId = id // 编辑id
        this.dialogTitle = '编辑'
        this.getsetRoleMessageList(id)
      }
    },
    // 弹框中的取消按钮
    cancellation() {
      this.centerDialogVisible = false
    },
    // 新增或者编辑
    submitForm(formName) {
      // 提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle == '添加角色') {
            //新增角色
            this.addRoleMessageList() //新增
          } else if (this.dialogTitle == '编辑') {
            //编辑
            this.editAddRoleMessageList(this.editId) //
          }
        } else {
          return false
        }
      })
    },
    //清空
    //查询列表数据
    nSubmit() {
      this.getRoleMessageList() //查询列表
    },
    //新增角色列表
    addRoleMessageList() {
      this.loading = true //加载中
      this.$api.system
        .addRoleMessageList(
          this.dialogformInline.description, //描述
          this.dialogformInline.role, //角色
          this.id
        )
        .then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.centerDialogVisible = false
            this.$message({ type: 'success', message: res.msg })
            this.getRoleMessageList()
          } else {
            this.loading = false
          }
        })
    },
    // 编辑保存
    editAddRoleMessageList(id) {
      this.loading = true //加载中
      this.$api.system
        .addRoleMessageList(
          this.dialogformInline.description, //描述
          this.dialogformInline.role, //角色
          id
        )
        .then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.centerDialogVisible = false
            this.$message({ type: 'success', message: res.msg })
            this.getRoleMessageList()
          } else {
            this.loading = false
          }
        })
    },
    usrReset() {
      this.formInline.role = ''
      this.getRoleMessageList()
    },
    //列表数据编辑获取信息
    getsetRoleMessageList(id) {
      this.loading = true //加载中
      this.$api.system.getsetRoleMessageList(id).then((res) => {
        if (res.code == 200) {
          this.centerDialogVisible = true
          this.loading = false
          this.dialogformInline.description = res.data.describes //描述
          this.dialogformInline.role = res.data.name //角色
        } else {
          this.loading = false
        }
      })
    },

    // 权限接口
    rolePermissions() {
      this.$api.designManagement.rolePermissions().then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: res.msg })
        }
      })
    }
  }
}
</script>
<style scoped>
.permissions {
  overflow-y: scroll;
  height: 300px;
}

.oneClass {
  display: flex;
  align-items: center;
  border-bottom: solid 1px #eeeeee;
  padding: 20px 0;
}

.onecheckbox,
.twocheckbox {
  width: 200px;
}

.trecheckbox {
  margin-right: 20px;
}

.btnPermissions {
  padding: 30px 150px;
}

.btn {
  margin-left: 50px;
}

.twoClass {
  display: flex;
  align-items: center;
}

el-input {
  width: 110%;
}

.dialogformInline1 {
  width: 324px;
}
</style>